module.exports = __webpack_public_path__ + "media/american-kestrel-1.3720541d.mp3";